"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensFieldDetailsDialog = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
const FieldDetailsDialog_1 = require("../FieldDetails/FieldDetailsDialog");
const FieldPropertyComponents_1 = require("../FieldDetails/FieldPropertyComponents");
const renderQueryResult_1 = require("../renderQueryResult");
const dialogWidth = 500;
class LensFieldDetailsDialog extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderLensFieldDetails = (data) => {
            var _a, _b;
            const field = data.lensFields && data.lensFields[0];
            if (!field) {
                return null;
            }
            const fieldIcon = (0, FieldFunctions_1.iconForField)(field.datasourceField);
            const datasource = (_a = field === null || field === void 0 ? void 0 : field.datasourceField) === null || _a === void 0 ? void 0 : _a.datasource;
            const datasourceVizPortalUrlId = (datasource === null || datasource === void 0 ? void 0 : datasource.__typename) === 'PublishedDatasource'
                ? datasource === null || datasource === void 0 ? void 0 : datasource.vizportalUrlId
                : null;
            return (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'field-details', title: catalog_messages_1.Messages.FieldDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: dialogWidth, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: this.props.onClose, handleGlassClick: this.props.onClose },
                react_1.default.createElement(FieldDetailsDialog_1.FieldDetailsPane, null,
                    react_1.default.createElement(FieldDetailsDialog_1.FieldDetailsFieldName, null, field.name || field.datasourceField.name),
                    react_1.default.createElement(FieldDetailsDialog_1.FieldDetailsTypeRow, null,
                        react_1.default.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon }),
                        fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : null),
                    react_1.default.createElement(FieldDetailsDialog_1.FieldDetailsProperties, null,
                        react_1.default.createElement(FieldPropertyComponents_1.FieldPropertyDescription, { labelFunc: catalog_messages_1.Messages.Description, description: field.description || field.datasourceField.description }),
                        this.renderTypeSpecificFieldDetails(field.datasourceField),
                        react_1.default.createElement(FieldPropertyComponents_1.ConnectedDatasourceField, { datasourceVizPortalUrlId: datasourceVizPortalUrlId, fieldId: field === null || field === void 0 ? void 0 : field.datasourceField.id, fieldName: (_b = field === null || field === void 0 ? void 0 : field.datasourceField) === null || _b === void 0 ? void 0 : _b.name })))));
        };
    }
    render() {
        return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.LensFieldDetailsDocument, variables: { lensFieldId: this.props.fieldId } }, result => react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: { renderData: this.renderLensFieldDetails } })));
    }
    renderTypeSpecificFieldDetails(field) {
        if (field.__typename !== 'DatasourceField') {
            return (0, FieldDetailsDialog_1.RenderTypeSpecificNonDatasourceFieldDetails)(field, this.props.makeFieldUrl);
        }
        else if (field.remoteField) {
            return (0, FieldDetailsDialog_1.RenderTypeSpecificNonDatasourceFieldDetails)(field.remoteField, this.props.makeFieldUrl);
        }
        else {
            return null;
        }
    }
}
exports.LensFieldDetailsDialog = LensFieldDetailsDialog;
//# sourceMappingURL=LensFieldDetailsDialog.js.map